<template>
  <v-app>
    <v-app-bar app extended extension-height="0">
      <template v-if="!isLogin">
        <v-app-bar-nav-icon :disabled="isMenu">
          <v-img
            v-if="isMenu"
            :src="require('@/assets/favicon.png')"
            alt="Fernheim Logo"
            height="36px"
            width="36px"
            contain
          ></v-img>

          <v-btn v-else @click="navigateToParent" icon>
            <v-icon>arrow_back</v-icon>
          </v-btn>
        </v-app-bar-nav-icon>

        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-toolbar-items v-if="isLoggedIn">
          <v-menu offset-y left>
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on">
                <v-icon class="pr-1">person</v-icon>
                <span class="text-none hidden-xs-only">{{
                  nombreOperador
                }}</span>
                <v-icon small>arrow_drop_down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item class="hidden-sm-and-up">
                <v-list-item-title>{{ nombreOperador }}</v-list-item-title>
              </v-list-item>
              <v-list-item :to="{ name: 'Logout' }">
                <v-list-item-action>
                  <v-icon>power_settings_new</v-icon>
                </v-list-item-action>
                <v-list-item-title>Cerrar Sesión</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </template>

      <!-- Not logged in -->
      <template v-else>
        <v-spacer></v-spacer>
        <v-img
          :src="require('@/assets/logo.png')"
          alt="Fernheim Logo"
          height="40px"
          contain
        >
        </v-img>
        <v-spacer></v-spacer>
      </template>

      <fh-progress slot="extension"></fh-progress>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <v-row justify="center">
          <v-col lg="8">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <fh-snackbar></fh-snackbar>
  </v-app>
</template>

<script>
import FhSnackbar from "@/components/FhSnackbar";
import FhProgress from "@/components/FhProgress";
import { mapGetters, mapState } from "vuex";

export default {
  name: "App",
  components: { FhProgress, FhSnackbar },
  data() {
    return {
      title: "Socio Fernheim",
    };
  },
  computed: {
    ...mapState("user", ["nombreOperador"]),
    ...mapGetters("auth", ["isLoggedIn"]),
    isMenu() {
      return this.$route.path === "/";
    },
    isLogin() {
      return this.$route.path === "/login";
    },
  },
  methods: {
    navigateToParent() {
      if (
        this.$route.name === "RequestResetPin" &&
        !!this.$route.query.nombre &&
        !!this.$route.query.redirect
      ) {
        this.$router.push({
          name: this.$route.meta.parent || "Login",
          query: {
            nombre: this.$route.query.nombre,
            redirect: this.$route.query.redirect,
          },
        });
      } else {
        this.$router.push({ name: this.$route.meta.parent || "Login" });
      }
    },
    loadMaterialIcons() {
      // From https://allthingssmitty.com/2016/09/12/checking-if-font-awesome-loaded/
      let span = document.createElement("span");
      span.className = "material-icons";
      span.style.display = "none";
      document.body.insertBefore(span, document.body.firstChild);

      function css(element, property) {
        return window
          .getComputedStyle(element, null)
          .getPropertyValue(property);
      }

      // https://github.com/panthershark/safari-cache-bug
      if (
        css(span, "font-family") !== '"Material Icons"' ||
        navigator.vendor.match(/apple/i)
      ) {
        import(
          /* webpackChunkName: "materialIcons" */ "material-design-icons-iconfont/dist/material-design-icons.css"
        );
      }

      document.body.removeChild(span);
    },
  },
  created() {
    setTimeout(() => this.loadMaterialIcons(), 5000);
  },
};
</script>

<style scoped>
/* Extend progress indicator over whole toolbar */
/*noinspection CssUnusedSymbol*/
.v-toolbar >>> .v-toolbar__extension {
  padding: 0;
}
</style>
